<template>
    <div class="row panels_info">
        <div class="col-sm-4">
            <router-link :to="{ name: 'incoming.index' }" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" :class="{ 'has-pending': numbers.pending_incoming > 0 }" v-pml-block="isLoading">
                <i class="wi wi-cloud-up text-primary"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.pending_incoming }}</h2>
                <div class="text-muted m-t-5">{{ $t('incoming_deals') }}</div>
            </router-link>
        </div>
        <div class="col-sm-4">
            <a href="/deals?status_s=open&show_lonely=false" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-user text-info"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.open_deals }}</h2>
                <div class="text-muted m-t-5">{{ $t('open_deals') }}</div>
            </a>
        </div>
        <div class="col-sm-4">
            <a href="/deals?status_s=open&show_lonely=true" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-headphone-alt text-pink"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.free_deals }}</h2>
                <div class="text-muted m-t-5">{{ $t('lonely_deals') }}</div>
            </a>
        </div>
        <div class="col-sm-6 col-md-3">
            <a href="/quotations?deal_status_s=open&status_s=new" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-pencil text-purple"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.pending_quotes }}</h2>
                <div class="text-muted m-t-5">{{ $t('pending_quotations') }}</div>
            </a>
        </div>
        <div class="col-sm-6 col-md-3">
            <a href="/quotations?deal_status_s=open&status_s=sent" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-share text-warning"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.sent_quotes }}</h2>
                <div class="text-muted m-t-5">{{ $t('sent_quotations') }}</div>
            </a>
        </div>
        <div class="col-sm-6 col-md-3">
            <a href="/quotations?deal_status_s=open&status_s=approved" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-thumb-up text-custom"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.approved_quotes }}</h2>
                <div class="text-muted m-t-5">{{ $t('approved_quotations') }}</div>
            </a>
        </div>
        <div class="col-sm-6 col-md-3">
            <a href="/quotations?deal_status_s=open&status_s=refused" class="box_shadow_hover widget-panel show widget-style-2 bg-white min_h_98" v-pml-block="isLoading">
                <i class="ti-thumb-down text-danger"></i>
                <h2 class="m-0 text-dark font-600">{{ numbers.refused_quotes }}</h2>
                <div class="text-muted m-t-5">{{ $t('refused_quotations') }}</div>
            </a>
        </div>
    </div>
</template>

<script>
    import { getNumbers } from 'services/dashboard'

    export default {
        name: 'Numbers',
        data () {
            return {
                isLoading: false,
                numbers: {}
            }
        },
        mounted () {
            this.initNumbers()
        },
        methods: {
            initNumbers () {
                this.isLoading = true

                getNumbers()
                       .then(response => {
                           this.numbers = response.data
                           this.isLoading = false
                       })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/widgets/Numbers.vue